export default __webpack_public_path__ + "fbb3ff0aba476bd488f40c20f9ea1e31.svg";